import type { User } from "~/types/oauth";

const OAUTH_USER_KEY = "oauth_user";

export function getOAuthUser(): User | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const userData = localStorage.getItem(OAUTH_USER_KEY);
    if (!userData) {
      return null;
    }
    return JSON.parse(userData) as User;
  } catch (error) {
    console.error("Error parsing oauth user from localStorage:", error);
    return null;
  }
}

export function setOAuthUser(user: User): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(OAUTH_USER_KEY, JSON.stringify(user));
  } catch (error) {
    console.error("Error setting oauth user in localStorage:", error);
  }
}

export function removeOAuthUser(): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(OAUTH_USER_KEY);
  } catch (error) {
    console.error("Error removing oauth user from localStorage:", error);
  }
}

export function updateOAuthUser(updates: Partial<User>): void {
  const currentUser = getOAuthUser();
  if (currentUser) {
    const updatedUser = { ...currentUser, ...updates };
    setOAuthUser(updatedUser);
  }
}
